package com.essntl.features.paymentparameter.ui.addeditpaymentparameter

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel

data class AddEditPaymentParameterState(
    val paymentParameter: MutableState<PaymentParameterModel> = mutableStateOf(
        PaymentParameterModel.empty.copy(
            method = PaymentParameterModel.Method.Add,
            type = PaymentParameterModel.Type.FlatFee,
        ),
    ),
    val getPaymentParameter: State<PaymentParameterModel> = State(),
    val addEditPaymentParameter: State<PaymentParameterModel> = State(),
    val isEditEnabled: Boolean = false,
)
